
const BASE_URL = process.env.REACT_APP_BACKEND_URL

export const login_api = async(useremail,password) => {
   const response = await fetch(`${BASE_URL}/api/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({"useremail":useremail,"password":password}),
  });

  if (response.ok) {
    return await response.json(); // { message: "User registered successfully" }
  }
  // Handle error responses
  if (response.status === 401) {
    throw new Error("Incorrect useremail/password");
  } else if (response.status === 400) {
    throw new Error("Email and password are required");
  } else {
    throw new Error("Login failed. Internal Server Error");
  }

  }

export const register_api = async (useremail,password) => {
  const response = await fetch(`${BASE_URL}/api/auth/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({"useremail":useremail,"password":password}),
  });

  if (response.ok) {
    return await response.json(); // { message: "User registered successfully" }
  }
  // Handle error responses
  if (response.status === 409) {
    throw new Error("User already exists");
  } else if (response.status === 400) {
    throw new Error("Email and password are required");
  } else {
    throw new Error("Registration failed. Please try again.");
  }
};
